// @flow

import * as React from 'react';
import classnames from 'classnames';
import {
  AnalyticsContext,
  AnalyticsLocationConsumer,
  trackEvent
} from 'latitude-analytics';
import SvgInline from '@latitude/svg-inline';
import './_logon-button.scss';

type Props = {
  active?: boolean,
  className?: string,
  mobileVisible: boolean, // Is the button visible on mobile
  children: React.Node,
  onClick: () => void,
  label?: string
};

type Ref = { current: null | HTMLElement };

// Use ref forwarding to obtain a ref to the <button> element
// https://reactjs.org/docs/forwarding-refs.html
const LogonButton = React.forwardRef((props: Props, ref: Ref) => {
  const [analytics] = React.useContext(AnalyticsContext);

  const { active, children, className, mobileVisible, onClick, label } = props;

  const handleTracking = (
    event: SyntheticEvent<HTMLSelectElement>,
    analytics: Analytics,
    location: string
  ) => {
    onClick(); // toggles login form visibility

    if (trackEvent) {
      trackEvent(analytics, {
        category: 'log in',
        action: 'interaction',
        label: 'log in',
        location
      });
    }
  };

  return (
    <AnalyticsLocationConsumer>
      {(location: string) => (
        <div className="logon-button-wrapper">
          <button
            ref={ref}
            className={classnames('logon-button', className, {
              'mobile-visible': mobileVisible,
              'is-active': active
            })}
            type="button"
            aria-label="Log in"
            onClick={(event: SyntheticEvent<HTMLAnchorElement>) =>
              handleTracking(event, analytics, location)
            }
          >
            <SvgInline className="profile-icon" name="person" />
            <div className="logon-button__label">{label || 'Log in'}</div>
            <SvgInline
              aria-label="Down"
              name={active ? 'chevron-up' : 'chevron-down'}
              className="up-down-icon"
            />
          </button>
          {children}
        </div>
      )}
    </AnalyticsLocationConsumer>
  );
});

export default LogonButton;
